<template>
  <div>
    <el-cascader :props="areaProps"
                 :options="options"
                 v-model="values"
                 :clearable="true"
                 @change="handleChange"
                 ref="cascader"
                 :key="modalKey"
                 v-if="cascaderShow"
                 :show-all-levels="true"
    />
  </div>
</template>

<script>

export default {
  name: "index",
  props: ['maximumLevel'],
  data() {
    return {
      cascaderShow: true,
      areaNamePath: '',
      modalKey: 0,
      echoAddressUrl: '/basic/basArea/getAreaOptionByAreaNamePath',
      // getAreaArrayUrl: '/basic/basArea/getAreaNamePath',
      // getAreaOptionUrl: '/basic/basArea/getAreaOption',
      values: [],
      options: [],
      areaProps: {
        lazy: true,
        // value: this.values,
        // emitPath: true,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      selected: {
        country: '',
        province: '',  // 省
        city: '',  // 市
        county: '',  // 区
        town: '',  // 街道
      },
      area: {
        country: '',
        province: '',
        city: '',
        county: '',
        town: '',
      },
      temp: 1,
    }
  },

  watch: {
    areaNamePath() {
      this.echoAddress()
    },
    area: {
      handler(newVal, oldVal) {
        console.log(newVal, 'area')
        this.$emit('areaObjChange', newVal)
      },
      deep: true
    }
  },
  methods: {
    // 数据回显
    echoAddress() {
      // this.cascaderShow = false
      this.$http({
        url: this.echoAddressUrl,
        method: 'post',
        data: {areaNamePath: this.areaNamePath}
      }).then(res => {
        this.options = res.data.data.options
        this.values = res.data.data.values
        this.area = res.data.data.names
      })
    },

    determineIfThereIsASubset(data, node) {
      if (node.level < this.maximumLevel - 1) {
        return Number(data) !== 0
      }
      return true
    },



    cascaderLazyLoad(node, resolve) {
      console.log(
        'aksdfjksdfjksdk'
      )
      this.$http({
        url: '/basic/basArea/getList',
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
          if (node.level == this.maximumLevel) {
            resolve([])
            return
          }
          if (node.root) {
            const childrens = response.data.data || {};
            const childNodes = childrens.map(item => ({
              value: item.id,
              label: item.areaName,
              leaf: this.determineIfThereIsASubset(item.hasChild, node)
            }))
            console.log('childNodes', childNodes)
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(childNodes);
          } else {
            const childrens = response.data.data || {};
            let childNodes = []
            let temp = ''
            console.log(node.children, 'child')
            if (node.children.length !== 0) {
              temp = node.children
              childrens.forEach(item => {
                let flag = false
                temp.forEach(item1 => {
                  if (item1.value == item.id) {
                    flag = true  // 当前节点已存在此数据，不追加
                  }
                })
                if (!flag) {
                  childNodes.push({
                    value: item.id,
                    label: item.areaName,
                    leaf: this.determineIfThereIsASubset(item.hasChild, node)
                  })
                }
              })
              resolve(childNodes);
            } else {
              childrens.forEach(item => {
                childNodes.push({
                  value: item.id,
                  label: item.areaName,
                  leaf: this.determineIfThereIsASubset(item.hasChild, node)
                })
              })
              resolve(childNodes);
            }

          }
      })
    },


    handleChange() {
      const areaNode = this.$refs["cascader"].getCheckedNodes();
      console.log('handleNode', areaNode)
      if (areaNode!=null && areaNode[0]!=null && areaNode[0].value != null) {
        // this.area.areaId = areaNode[0].value;
        // console.log(this.area.areaId,"this.area.areaId");
        // this.areaName = areaNode.pathLabels;
        if (areaNode[0].level==1) {
          this.area.country = areaNode[0].label;
          this.area.province = null;
          this.area.city = null;
          this.area.county = null;
          this.area.town = null;
        } else if (areaNode[0].level==2){
          this.area.province = areaNode[0].label;
          this.area.city = null;
          this.area.county = null;
          this.area.town = null;
        } else if(areaNode[0].level==3){
          this.area.city = areaNode[0].label;
          this.area.county = null;
          this.area.town = null;
        } else if(areaNode[0].level==4){
          this.area.county = areaNode[0].label;
          this.area.town = null;
        } else if(areaNode[0].level==5){
          this.area.town = areaNode[0].label;
        }
      } else {
        this.area.country = null;
        this.area.province = null;
        this.area.city = null;
        this.area.county = null;
        this.area.town = null;
      }


      const panelRefs = this.$refs.cascader.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        // panelRefs.activePath.forEach(item => {
        //   // console.log('item', item)
        //   // // if (item.children.length !== 0) {
        //   // //   console.log(item.children, ';kdfasjaklsdfkasdf')
        //   // // }
        //   // console.log(panelRefs.getCheckedNodes()[0], 'ksdfjksadjf')
        // })
        panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      }
    }
  }
}
</script>

<style scoped>

</style>
